import React from 'react';
import { Box, Typography, Dialog, DialogContent, DialogActions, IconButton, DialogTitle } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import ButtonSmg from "../ButtonSmg";


const ImportantMessageDialog = ({ open, onClose }) => {

    const iconoWarningMessage = window._env_.PUBLIC_URL + '/assets/images/iconoWarningCircle.png';

    return (
          <Dialog open={open} onClose={onClose} PaperProps={{ style: { width: '680px', maxWidth: '80%' }}}> 
            <Box sx={{ width: '100%', maxWidth: '90vw', padding: 2 }}>
                                                                       
                <DialogTitle sx={{ p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}> 

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, sm: 4 } }}>
                            <img src={iconoWarningMessage} width={40} height={40} sx={{ marginRight: { xs: '16px', sm: '20px' } }} />
                            <Box sx={{ width: '12px' }} />
                            <Typography style={{ fontFamily: "Raleway, sans-serif", fontSize: "22px", lineHeight: "1.2",
                                    "@media (max-width: 600px)": { lineHeight: "1.1", fontSize: "18px", color: '#555353' } 
                                }}>
                                Información importante
                            </Typography>
                        </Box>

                        <IconButton edge="end" color="inherit" onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>


                <DialogContent sx={{ pb: 0, mb: 0, fontFamily: 'Inter, sans-serif', color: '#555353' }}>    
                    <Typography variant="body1" paragraph sx={{ textAlign: "left", fontSize: '14px' }}>
                        Por tareas de mantenimiento, nuestros canales no están disponibles.
                    </Typography>

                    <Typography variant="body1" style={{ marginBottom: '8px', marginTop: '22px', marginBottom: '28px' }}> 
                        Nuestras clínicas, guardias y la línea de emergencias siguen funcionando.
                        <b>En caso de una emergencia, pueden comunicarte las 24 horas al 0810-888-3226.</b>
                    </Typography>

                    <Typography variant="body1" paragraph sx={{ fontWeight: "bold", fontSize: '14px' }}>
                        Atenderemos las consultas administrativas cuando se recupere el servicio.
                    </Typography>
                </DialogContent>
                

                <DialogActions sx={{ p: 2, justifyContent: "center" }}>
                    <ButtonSmg theme="material" color="primary" size="large" content="Entendido" onClick={onClose} style={{ width: "250px", marginRight: "20px" }}  />
                </DialogActions>
                </Box>
            </Dialog>
    )
}

export default ImportantMessageDialog;
